var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"chevron-back","d":"M194,112l-10,10,10,10","transform":"translate(-183 -110.586)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"}));
}

Back.defaultProps = {"width":"12.414","height":"22.828","viewBox":"0 0 12.414 22.828"};

module.exports = Back;

Back.default = Back;
